import React, { useEffect, useState, useContext, useRef } from 'react';
import { IonButton, IonSlides, IonGrid, IonTabs, IonTab, IonTabBar, IonTabButton, IonToolbar, IonTitle, IonContent, IonHeader, IonLabel, IonRouterOutlet, IonFooter, IonCard, IonList, IonItem, IonicSlides, IonText, IonAlert, IonInput, IonIcon, IonLoading } from '@ionic/react';
import { useIonRouter, IonSlide, IonRow, IonCol, IonImg, IonRefresher, IonRefresherContent } from '@ionic/react';
import { Route, useHistory} from "react-router-dom";
import { Http } from '@capacitor-community/http';
import { searchOutline } from 'ionicons/icons'; // Import the search icon


//import { NativeBiometric } from "capacitor-native-biometric";
//import { BiometryType } from "capacitor-native-biometric";



import { Public_MerchantID_Context } from '../../../storeState/public_merchantID_context';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import { Hotel_PrivacyStatement } from '../components/PrivacyStatement';

import {RegisterBusinessModal} from '../components/Register_Business_Modal';
import {RegisterIndividualModal} from '../components/Register_Individual_Modal';

import {Search_Home} from '../components/Component_Search_Home';

import {Home_HotelsList} from '../components/Component_Home_Hotel';
import {Home_ProfessionalServicesList} from '../components/Component_Home_ProService';
import {Home_RetailServicesList} from '../components/Component_Home_RetailList';
import { MerchantLoginCredentials } from '../components/LoginCredentials_merchant';

import '../../css/layout.css'

export function Home () {


    let authMerchant_objects = useContext(Auth_MerchantID_context);

    let [acctID, setAcctID ] = useState(authMerchant_objects.acctID);
    let [baseURL, setBaseURL ] = useState(authMerchant_objects.baseURL);

    //alert('In HOME')
    let [homeView, setHomeView] = useState(null);

    let [merchantLoginModal, setMerchantLoginModal] = useState(false);
    let [clientLoginModal, setClientLoginModal] = useState(false);
    let [privacyStatementModal, setPrivacyStatementModal] = useState(false);

    let [showAlert, setShowAlert] = useState(false);

    let [registerModal_business, setRegisterModal_business] = useState(false);
    let [registerModal_individial, setRegisterModal_individual] = useState(false);

    //let [isBiometric_fingerprintAvilable, setIsBiometric_fingerprintAvilable ] = useState(authMerchant_objects.isBiometric_fingerprintAvilable);
    //let [biometric_fingerprint, setBiometric_fingerprint] = useState(authMerchant_objects.biometric_fingerprint);
    //let [device, setDevice ] = useState(authMerchant_objects.device);

    let publicMerchent_context = useContext(Public_MerchantID_Context);

    let [searchHomeList, setSearchHomeList] = useState('false');


    let [hotelList_component, setHotelList_component] = useState('true');
    let [proList_component, setProlList_component] = useState('false');
    let [retailList_component, setRetailList_component] = useState('false');

    let [color_hotels, setColor_hotels] = useState('outline')
    let [color_proServices, setColor_proServices] = useState('clear')
    let [color_retail, setColor_retail] = useState('clear')

    let [searchTerm, setSearchTerm] = useState(null);
    let [searchResults, setSearchResults] = useState([]);

    let [isloading, setLoading] = useState(false);

    let history = useHistory();
    let router = useIonRouter();

    let slideRef = useRef(null);

    let timeout;


    function handleInput(event) {

        //alert("In Handle Input");
        setSearchTerm('');
        setLoading(true);

        document.getElementById('searchSupplierNameList').innerHTML = '';

        clearTimeout(timeout); // Clear the previous timeout to reset the delay

        setSearchTerm(event[1]);
        timeout = setTimeout(searchSupplierList(event), 2000); // Set a new timeout

    
    }


    function searchSupplierList(event)
    {

        let searchCategory = event[0];
        let searchData = event[1];


        first_searchSuppliersInDB(searchCategory, searchData);
    }

    function first_searchSuppliersInDB(searchCategory, searchData, optionsData)
    {

        let formData = new FormData();
        let Tracker = '';


        if(searchCategory === 'search_home')
        {

            Tracker = '74002S_search_home';
        }

        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: Tracker,
                user: acctID,
                xSupplierSearchName: searchData,
                //sessionID: sessionID,
            })
        }

        fetch(baseURL+'merchants_argsApp', requestOptions)
        .then(res => res.text())
        .then(res => {

                        let rows = res.toString().split('~~~');

                        let rowLength = rows.length;


                        // alert("After Fetch");
                        // alert(res);
                        // alert(searchCategory);
                        // alert(rowLength);
                        // alert(rows);

                            for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                            {
                                let cols = rows[rownum].split('|');

                                if(searchCategory === 'search_home')
                                {
                                    //setSearchResults(cols);

                                    setSearchResults((prevSearchResults) => {
                                        return prevSearchResults.concat({
                                            id: cols[0],
                                            companyName: cols[1],
                                        })
                                    });
                                    //document.getElementById('searchSupplierNameList').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+[cols[0], cols[1], searchCategory,]+'\'>'+cols[0]+'</option>'); // onclick=\'inventoryItemsSearchResults('+cols[0]+')\'
                                }
                            }

                            if(rowLength >= 1)
                            {
                                setSearchHomeList('false');
                                setSearchHomeList('true');
                                setLoading(false);
                            }
                    })
        }



    function handleSearch(e) {

        setSearchTerm(e.target.value);

      };

    function hotelsHandler()
    {
        setHotelList_component('true');
        setProlList_component('false');
        setRetailList_component('false');

        setColor_hotels('outline');
        setColor_proServices('clear');
        setColor_retail('clear');


    }
    function proServicesHandler()
    {
        setHotelList_component('false');
        setProlList_component('true');
        setRetailList_component('false');

        setColor_hotels('clear');
        setColor_proServices('outline');
        setColor_retail('clear');

    }
    function retailHandler()
    {
        setHotelList_component('false');
        setProlList_component('false');
        setRetailList_component('true');

        setColor_hotels('clear');
        setColor_proServices('clear');
        setColor_retail('outline');

    }
    function searchItemHandler()
    {
        setHotelList_component('false');
        setProlList_component('false');
        setRetailList_component('false');

        setSearchHomeList('true');

        setColor_hotels('clear');
        setColor_proServices('clear');
        setColor_retail('clear');

    }

    function zPub_handleMerchantID(event) {

        publicMerchent_context.changeCompanyID(event[0]);
        publicMerchent_context.changeCompanyName(event[1]);

    }

    function resetToolbarHandler(event) {

        publicMerchent_context.changeCompanyID(null);
        publicMerchent_context.changeCompanyName('ghanaverified');

    }

    async function handleSlideChange()
    {

        //alert("In Handle Slide Change");
        let swiper = await slideRef.current?.getSwiper();

        //let activeIndex = swiper?.activeIndex; // Get the current slide index

        let realIndex = swiper?.realIndex; // Get the actual slide index (ignores duplicate slides)

        //alert(realIndex);
    
        if (realIndex === 0) { // Example: Execute a function when reaching slide 3
            hotelsHandler();
        }
        else if (realIndex === 1) { // Example: Execute a function when reaching slide 3
            proServicesHandler();
        }
        else if (realIndex === 2) { // Example: Execute a function when reaching slide 3
            retailHandler();
        }
        // else if (realIndex === 3) { // Example: Execute a function when reaching slide 3
            
        //     if(searchHomeList == 'true')
        //     {
        //         searchItemHandler();
        //     }
        //     else
        //     {
        //         swiper.slideTo(0, 100); // Redirect back if trying to access slide 3
        //        // hotelsHandler();
        //     }
        // }
      };

    function handleRegister_business() {

        authMerchant_objects.changeAccountID('register_request');
        setRegisterModal_business(true);
    }

    function handleRegister_individual() {

        authMerchant_objects.changeAccountID('register_request');
        setRegisterModal_individual(true);
    }

    const handleHomepage = () => {

        //alert("in handle homepage");
        //alert(authMerchant_objects.authenticated);

            if(authMerchant_objects.authenticated == 'T1')
            {
                //history.push('/hotel_merchantMainPageApp');
                router.push('/hotel_merchantMainPageApp', 'forward', 'replace');

            }
            else if(authMerchant_objects.authenticated == 'T2')
            {
                //history.push('/proService_merchantMainPageApp'); 
                router.push('/proService_merchantMainPageApp', 'forward', 'replace');

            }
            else if(authMerchant_objects.authenticated == 'T3')
            {
                //history.push('/retail_merchantMainPageApp'); 
                router.push('/retail_merchantMainPageApp', 'forward', 'replace');

            }
            else if(authMerchant_objects.authenticated == 'C1')
            {
                //history.push('/clientMainPageApp'); 
                router.push('/clientMainPageApp', 'forward', 'replace');

            }
      };


    const handleHomepage_zasava = () => {

        if (baseURL === "https://ghanaverified.com/") {
            window.location.href = "https://zasava.com";
        } 
        else if (baseURL === "https://ghanaverifiedtest.com/") {
            window.location.href = "https://zasavatest.com";
        }
  };

    const slideOpts = {
        initialSlide: 0, // Start at the first slide
        speed: 100, // Animation speed (in ms)
        loop: false, // Enable looping
      };

    
    function handleCloseModal()
    {
        authMerchant_objects.changeAccountID(null);   
        setRegisterModal_business(false);
        setRegisterModal_individual(false);
    }

    async function reRender() 
    {
        //alert("DataRetrieved");
        let swiper = await slideRef.current?.getSwiper();

        slideRef.current.update();

        if(searchHomeList == 'true')
        {
            swiper.slideTo(3, 0); // Instantly switch to the specified slide
            swiper.allowTouchMove = false; // Prevent further navigation
            searchItemHandler();
        }


    }

    async function reOpenSwipe(event) 
    {
        //alert("DataRetrieved");
        //alert(event);
        
        let swiper = await slideRef.current?.getSwiper();

        if(searchHomeList == 'true')
        {
            setSearchHomeList('false');
            swiper.allowTouchMove = true; // Allow further navigation
            setSearchTerm('');

        // Wait for state to update before proceeding
            setTimeout(() => {  

                if (event === 0) {
                    
                    // Force move to index 1 first, then back to 0
                    slideRef.current?.slideTo(1, 100);  
    
                    setTimeout(() => {
                        slideRef.current?.slideTo(0, 100);
                    }, 50); // Small delay to ensure state change
                } else {
                    slideRef.current?.slideTo(event, 100);
                }
            }, 0); // A small delay to ensure state updates before calling slideTo
        }
        else
        {
            slideRef.current?.slideTo(event, 100);
            setSearchHomeList('false');
        }


    }
    function safeJsonParse(jsonString) {
        return (typeof JSON.parse === 'function') ? JSON.parse(jsonString) : null;
      }

    function handleRefresh(event)
    {
        // Optional: Delay to show the spinner briefly
        setTimeout(() => {
        event.detail.complete();   // Stop the spinner
        window.location.reload();  // Reload the entire app
        }, 500);
    }

    //alert("In Homme");
    //alert(window.location.pathname)
    //alert(authMerchant_objects.authenticated);
    // // alert(authMerchant_objects.acctID);
    //  alert(authMerchant_objects.initialSetup);
    //  alert(authMerchant_objects.initialSetup.details);
    //  alert(authMerchant_objects.initialSetup?.details?.step_1);
    //alert(JSON.parse(authMerchant_objects.initialSetup.details)?.step_1);

    // alert(authMerchant_objects.initialSetup.setup_id);
    // alert(authMerchant_objects.initialSetup?.details?);
    //alert(authMerchant_objects.initialSetup?.details?.step_1);
    //alert(safeJsonParse(authMerchant_objects.initialSetup[1]));
    //alert(authMerchant_objects.initialSetup?.details?);


    return (
            <React.Fragment>
                <IonContent fullscreen>
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent
                    pullingText="Pull to refresh the app"
                    refreshingSpinner="circles"
                    refreshingText="Refreshing app..."
                    />
                </IonRefresher>

                <IonHeader >
                        <IonGrid   className='grid_header' >
                           {authMerchant_objects.authenticated == null && <IonRow className='gh_top_links_row'>
                                    <IonCol size='9' style={{ fontSize: "16px", textAlign: "left"}} ><a onClick={() => setShowAlert(true)}>Register</a></IonCol>
                                    <IonCol size='3' style={{ fontSize: "16px", textAlign: "center"}} >
                                        <a  onClick={() => setMerchantLoginModal(true)}>Login</a>
                                        <a > </a>
                                    </IonCol>
                                    {/*<div style={{ fontSize: "16px", display: "flex", gap: "10px" }} >
                                        <a  onClick={() => setMerchantLoginModal(true)}>Sign-in</a>
                                        <a  >Contact</a>
                                    </div>*/}
                            </IonRow>}
                            {authMerchant_objects.authenticated != null && <IonRow className='gh_top_links_row'>
                                    <IonCol size='9' style={{ fontSize: "16px", textAlign: "left"}} ><a></a></IonCol>
                                    {(authMerchant_objects.initialSetup?.details?.step_1 == false || authMerchant_objects.initialSetup?.details?.step_2 == false || authMerchant_objects.initialSetup?.details?.step_3 == false || authMerchant_objects.initialSetup?.details?.step_4 == false) 
                                    ?
                                    <IonCol size='3' style={{ fontSize: "16px",  textAlign: "center"}} >
                                        <a  className='flash-tutorial' onClick={() => handleHomepage()}>Home</a>
                                        <a > </a>
                                    </IonCol>
                                        :
                                    <IonCol>
                                        <a   onClick={() => handleHomepage()}>Home</a>
                                        <a > </a>
                                    </IonCol>}
                            </IonRow>}
                            <IonRow >
                                <IonCol size='12'>
                                    <IonLabel style={{ color: "white"}}>GH-VERIFIED</IonLabel>
                                </IonCol>
                            </IonRow>
                            {/*<IonRow >
                                <IonCol>
                                    {homeView == '1' &&  <IonItem><MerchantLogin /></IonItem>}

                                    {homeView == '2' &&  <IonItem><UserLogin   /></IonItem>}
                                </IonCol>
                            </IonRow>*/}
                            <IonRow>
                                <IonCol size = '4'>
                                    <IonButton className='tab_buttons' fill={color_hotels} onClick={() => reOpenSwipe(0)}> <IonLabel>Hotels</IonLabel> </IonButton>
                                </IonCol>
                                <IonCol size = '4'>
                                    <IonButton className='tab_buttons' fill={color_proServices} onClick={() => reOpenSwipe(1)}> <IonLabel>Pro Services</IonLabel></IonButton>
                                </IonCol>
                                <IonCol size = '4'>
                                    <IonButton className='tab_buttons' fill={color_retail} onClick={() => reOpenSwipe(2)}> <IonLabel>Retail</IonLabel> </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                </IonHeader>

              {searchHomeList != 'true' &&  <IonContent className='grid_content'>

                    <IonSlides ref={slideRef} onIonSlideDidChange={handleSlideChange} options={slideOpts}>
                         <IonSlide className='merchantList_Content_main'>

                           {hotelList_component == 'true' && <Home_HotelsList openModal={ hotelList_component } confirmComplete={() => reRender()} ></Home_HotelsList>}

                        </IonSlide>
                        <IonSlide className='merchantList_Content_main'>
                            {proList_component == 'true' && <Home_ProfessionalServicesList openModal={ proList_component } confirmComplete={() => reRender()} ></Home_ProfessionalServicesList>}

                        </IonSlide>
                        <IonSlide className='merchantList_Content_main'>
                            {retailList_component == 'true' && <Home_RetailServicesList openModal={ retailList_component } confirmComplete={() => reRender()} ></Home_RetailServicesList>}

                        </IonSlide>
                    </IonSlides>

                    <Hotel_PrivacyStatement openModal={ privacyStatementModal } closeModal={() => setPrivacyStatementModal(false)} ></Hotel_PrivacyStatement>

                    {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}
                    
                </IonContent>}


                {searchHomeList == 'true' &&   <IonContent className='grid_content'>

                    <IonSlides ref={slideRef} onIonSlideDidChange={handleSlideChange} className='merchantList_Slide_Dimension' options={slideOpts}>

                             <IonSlide className='merchantList_Content_main'>
                            {searchHomeList == 'true' && <Search_Home openModal={ searchHomeList } confirmComplete={() => reRender()} data={{
                                                        searchData: searchTerm, 
                                                        }}></Search_Home>}
                        </IonSlide>
                    </IonSlides>

                    <Hotel_PrivacyStatement openModal={ privacyStatementModal } closeModal={() => setPrivacyStatementModal(false)} ></Hotel_PrivacyStatement>

                    {isloading == true && <IonLoading
                        isOpen={isloading}
                        message={'Please wait...'}
                        duration={0} // Show until manually dismissed
                    />}

                </IonContent>}
                
                {registerModal_business == true && <RegisterBusinessModal  openModal={registerModal_business} closeModal={() => handleCloseModal()}></RegisterBusinessModal>}
                {registerModal_individial == true && <RegisterIndividualModal  openModal={registerModal_individial} closeModal={() => handleCloseModal()} data={{
                                                        source: '', 
                                                        }}></RegisterIndividualModal>}

                {merchantLoginModal == true && <MerchantLoginCredentials openModal={ merchantLoginModal } closeModal={() => setMerchantLoginModal(false)} data={{
                                                        source: '', 
                                                        }}></MerchantLoginCredentials>}

                { showAlert == true && <IonAlert
                    isOpen={showAlert}
                    header="Confirm"
                    message="ARE YOUR REGISTERING AS A BUSINESS?"
                    buttons={[
                    {
                        text: "No",
                        handler: () => handleRegister_individual(),
                    },
                    {
                        text: "Yes",
                        handler: () => handleRegister_business(),
                    },
                    ]}
                    onDidDismiss={() => setShowAlert(false)}
                />}

                <IonFooter class='appFooter'>
                    <IonGrid>
                        <IonRow className='gh_bottom_links_row'>
                           {/*} {(authMerchant_objects.authenticated != null && authMerchant_objects.acctID == "G1") &&
                                <IonCol size='1'>
                                    <IonButton className='small_button' onClick={() => handleHomepage_zasava()}>Zasava</IonButton>
                                </IonCol>
                            }*/}
                                <IonCol size='8'>
                                    <input 
                                    className='professional-input'
                                    type='text' 
                                    id='searchSupplierName' 
                                    value={ searchTerm } 
                                    placeholder='Search Merchant' 
                                    debounce={500}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setSearchTerm(value);
                                        // Get all datalist options
                                        const dataList = document.getElementById('searchSupplierNameList');
                                        const options = Array.from(dataList.getElementsByTagName('option'));
                        
                                        // Check if selected value exists in datalist options
                                        const isValidSelection = options.some(option => option.value === value);
                        
                                        if (isValidSelection) {
                                            handleInput(['search_home', value]); // Fire only if selected
                                        }
                                    }}
                                    list='searchSupplierNameList' 
                                    autocomplete='off' 
                                    clearInput // Optional: Adds a clear button inside the input
                                    required></input>
                                    <datalist id='searchSupplierNameList'>
                                        {searchResults.map((result) => (
                                            <option key={result.id} value={result.companyName}></option>
                                        ))}
                                    </datalist>
                                   {/*} <IonInput
                                    value={searchTerm}
                                    onIonInput={handleSearch}
                                    debounce={500}
                                    placeholder="Enter search"
                                    clearInput // Optional: Adds a clear button inside the input
                                    />*/}
                                </IonCol>
                                <IonCol size='2'>
                                    <IonButton 
                                        className='professional-button'
                                        fill="clear"
                                        onClick={() => {
                                            const inputElement = document.getElementById('searchSupplierName');
                                            const selectedValue = inputElement.value;
                            
                                            // Check again if the value exists in the datalist

                                            handleInput(['search_home', selectedValue]); // Fire only if valid
                                        }}
                                    >
                                    </IonButton>
                                </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonFooter>
                </IonContent>
            </React.Fragment>

        );
}


